module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/top_bubble-70b8be6eb91cd6fd782886a2562db7ad.png";